import React from 'react';
import { Box, useTheme } from '@mui/material';
import { layoutGap } from '../../../theme/theme';
import { CaptionText } from '../typography';
import { InlineReadinessBadge, WorkflowVisualVariant } from './WorkflowStepComponents';

export interface WorkflowFooterProps {
  isReady: boolean;
  readyText?: string;
  blockedReasons?: string[];
  /** Accepted for call-site compatibility; the footer no longer frames itself per variant. */
  variant?: WorkflowVisualVariant;
}

export const WorkflowFooter: React.FC<WorkflowFooterProps> = ({
  isReady,
  readyText = 'Required inputs are complete',
  blockedReasons = [],
}) => {
  const theme = useTheme();
  const summaryText = isReady ? readyText : blockedReasons.join(' • ');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: { xs: layoutGap.micro, sm: layoutGap.row },
        minWidth: 0,
        width: { xs: '100%', sm: 'auto' },
      }}
    >
      <InlineReadinessBadge
        label={isReady ? 'Can continue' : 'Action needed'}
        tone={isReady ? 'ready' : 'blocked'}
        compact
      />
      <CaptionText
        sx={{
          color: theme.palette.text.secondary,
          whiteSpace: { xs: 'normal', sm: 'nowrap' },
          overflow: { xs: 'visible', sm: 'hidden' },
          textOverflow: { sm: 'ellipsis' },
          lineHeight: 1.3,
        }}
      >
        {summaryText}
      </CaptionText>
    </Box>
  );
};

export default WorkflowFooter;
